<div class="questions__container container">
  <div class="row"
  [style.minHeight.px]="rowHeight"
  [appHighlight]="highlightColor" 
  [defaultColor]="defaultColor"
  (color)="handleMouseEvent( $event)">
    <div class="question" [ngClass]="cssClass">
      <label>{{questionNo}}</label>
      <p>{{ question }}</p>
    </div>
    <div [ngClass]="componentClass" class="button-container">
      <mat-button-toggle-group
        name="{{name}}"
        [(ngModel)]="selectButton"
        (change)="buttonHandler($event)">
        <mat-button-toggle [value]="yes">{{yes}}</mat-button-toggle>
        <mat-button-toggle [value]="no">{{no}}</mat-button-toggle>
      </mat-button-toggle-group>
    </div>
  </div>
      
</div>